"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExclusiveOfferHero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2179" id="exclusiveofferhero" className="bg-white border-y border-border text-foreground relative w-full min-h-screen lg:h-screen overflow-hidden">
      <div className="flex flex-col lg:flex-row w-full min-h-screen lg:h-screen lg:pl-[84px]">
        {}
        <div ref={leftRef} className={`relative w-full lg:w-1/2 min-h-[50vh] lg:h-full flex flex-col justify-between px-6 sm:px-10 lg:px-16 pt-20 lg:pt-24 pb-12 lg:pb-16 transition-all duration-[800ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`} style={{
        backgroundColor: "hsl(0 0% 100%)",
        color: "hsl(0 0% 7%)"
      }}>
          <div className="relative z-10 max-w-xl">
            <p className="font-default text-xs sm:text-[13px] tracking-[0.25em] uppercase mb-6 lg:mb-8" style={{
            color: "hsl(45 68% 47%)"
          }}>
              Season I &middot; New Arrivals
            </p>
            <h1 className="font-default font-semibold text-[44px] sm:text-6xl lg:text-7xl xl:text-[88px] leading-[0.95] mb-6 lg:mb-8" style={{
            letterSpacing: "-0.02em"
          }}>
              Elevate your <em className="italic font-light">everyday</em>
              <br />
              style effortlessly.
            </h1>
            <p className="font-default text-base leading-relaxed max-w-[520px] mb-8 lg:mb-0" style={{
            color: "hsl(0 0% 40%)"
          }}>
              Discover our latest collection of premium fashion essentials. Crafted with precision, designed for comfort, and curated to make a statement in every setting.
            </p>
          </div>

          <div className="relative lg:absolute lg:inset-x-0 lg:bottom-0 lg:h-[60%] w-full mt-8 lg:mt-0 overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_premium_collection.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_premium_collection.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_premium_collection.webp-wvc-sizes" alt="Model wearing premium fashion apparel in a modern studio setting" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            <div className="absolute inset-0 pointer-events-none" style={{
            background: "linear-gradient(to top, hsl(0 0% 100%) 0%, hsla(0 0% 100%, 0.4) 100%)"
          }} />
          </div>

          <div className="relative z-10 mt-8 lg:mt-0 lg:absolute lg:bottom-12 lg:left-16">
            <Button asChild variant="outline" size="lg" className="font-default tracking-[0.15em] uppercase text-xs h-12 px-6 rounded-lg border bg-transparent hover:bg-secondary" style={{
            borderColor: "hsl(0 0% 7%)",
            color: "hsl(0 0% 7%)"
          }}>
              <Link to="/ShopPage">
                Shop Collection
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="hidden lg:flex absolute top-0 bottom-0 left-1/2 lg:left-[calc(84px+((100%-84px)/2))] -translate-x-1/2 w-px flex-col items-center justify-center z-20 pointer-events-none">
          <div className="flex-1 w-px" style={{
          backgroundColor: "hsl(45 68% 47% / 0.5)"
        }} />
          <div className="my-2 flex items-center justify-center" style={{
          color: "hsl(45 68% 47%)"
        }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2 L13 11 L22 12 L13 13 L12 22 L11 13 L2 12 L11 11 Z" fill="currentColor" opacity="0.8" />
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
            </svg>
          </div>
          <div className="flex-1 w-px" style={{
          backgroundColor: "hsl(45 68% 47% / 0.5)"
        }} />
        </div>

        {}
        <div className="lg:hidden flex items-center justify-center w-full" style={{
        backgroundColor: "hsl(0 0% 7%)"
      }}>
          <div className="flex-1 h-px" style={{
          backgroundColor: "hsl(45 68% 47% / 0.5)"
        }} />
          <div className="mx-3 flex items-center justify-center" style={{
          color: "hsl(45 68% 47%)"
        }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2 L13 11 L22 12 L13 13 L12 22 L11 13 L2 12 L11 11 Z" fill="currentColor" opacity="0.8" />
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
            </svg>
          </div>
          <div className="flex-1 h-px" style={{
          backgroundColor: "hsl(45 68% 47% / 0.5)"
        }} />
        </div>

        {}
        <div ref={rightRef} className={`relative w-full lg:w-1/2 min-h-[50vh] lg:h-full flex flex-col justify-between px-6 sm:px-10 lg:px-16 pt-16 lg:pt-24 pb-12 lg:pb-16 transition-all duration-[800ms] ease-[cubic-bezier(0.16,1,0.3,1)] delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`} style={{
        backgroundColor: "hsl(0 0% 7%)",
        color: "hsl(0 0% 100%)"
      }}>
          <div className="absolute inset-0 overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_exclusive_offer.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_exclusive_offer.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722769/img/fashion_exclusive_offer.png-wvc-sizes" alt="Close up of luxury fabric textures and fashion accessories" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-60" />
            <div className="absolute inset-0" style={{
            background: "linear-gradient(to bottom, hsl(0 0% 7% / 0.85) 0%, hsl(0 0% 7% / 0.55) 50%, hsl(0 0% 7% / 0.85) 100%)"
          }} />
          </div>

          <div className="relative z-10 max-w-xl">
            <p className="font-default text-xs sm:text-[13px] tracking-[0.25em] uppercase mb-6 lg:mb-8" style={{
            color: "hsl(45 68% 47%)"
          }}>
              Limited Time &middot; Exclusive Offer
            </p>
            <h2 className="heading text-[40px] sm:text-[2.5rem] leading-tight mb-6 lg:mb-8" style={{
            color: "hsl(0 0% 100%)",
            letterSpacing: "-0.02em"
          }}>
              Unlock your <em className="italic font-light">exclusive</em>
              <br />
              member discount.
            </h2>
            <div className="flex items-center gap-4 mb-6">
              <div className="border border-accent px-3 py-1">
                <span className="text-accent font-semibold text-xl">15% OFF</span>
              </div>
              <p className="font-default text-base leading-relaxed max-w-[400px]" style={{
              color: "hsl(0 0% 80%)"
            }}>
                Join our inner circle today and receive early access to seasonal sales.
              </p>
            </div>
            
            <div className="mt-8 max-w-sm">
              <input type="email" placeholder="Enter your email for access" className="w-full bg-transparent border-b border-white/20 py-2 outline-none focus:border-accent transition-all duration-300 placeholder:text-white/40 text-white" style={{
              borderWidth: '0 0 1px 0'
            }} />
            </div>
          </div>

          <div className="relative z-10 mt-12 lg:mt-0">
            <Button asChild size="lg" className="font-default tracking-[0.15em] uppercase text-xs h-12 px-8 bg-black text-white border border-black hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all duration-200">
              <Link to="/CheckoutPage">
                Join Now
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="hidden lg:flex absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex-col items-center gap-2 pointer-events-none">
        <span className="font-default text-[10px] tracking-[0.3em] uppercase" style={{
        color: "hsl(45 68% 47%)"
      }}>
          Scroll
        </span>
        <div className="w-px h-8" style={{
        backgroundColor: "hsl(45 68% 47% / 0.6)"
      }} />
        <ChevronDown className="h-3 w-3 animate-bounce" style={{
        color: "hsl(45 68% 47%)"
      }} />
      </div>
    </section>;
}